import { FC } from 'react';
import { AllieColors } from '../../common/color.types';

const VIEWBOX_CENTER_X = 50;
const VIEWBOX_CENTER_Y = 50;

export interface PathProps {
  className?: string;
  counterClockwise: boolean;
  pathRadius: number;
  strokeWidth: number;
  dashRatio: number;
  style?: object;
  strokeColor?: AllieColors;
}

export const Path: FC<PathProps> = ({
  className,
  counterClockwise,
  pathRadius,
  strokeWidth,
  dashRatio,
  style,
  strokeColor = 'success'
}) => {
  const getPathDescription = () => {
    const radius = pathRadius;
    const rotation = counterClockwise ? 1 : 0;

    return `
        M ${VIEWBOX_CENTER_X},${VIEWBOX_CENTER_Y}
        m 0,-${radius}
        a ${radius},${radius} ${rotation} 1 1 0,${2 * radius}
        a ${radius},${radius} ${rotation} 1 1 0,-${2 * radius}
      `;
  };

  const getDashStyle = () => {
    const diameter = Math.PI * 2 * pathRadius;
    const gapLength = (1 - dashRatio) * diameter;

    return {
      // Have dash be full diameter, and gap be full diameter
      strokeDasharray: `${diameter}px ${diameter}px`,
      // Shift dash backward by gapLength, so gap starts appearing at correct distance
      strokeDashoffset: `${counterClockwise ? -gapLength : gapLength}px`,
    };
  };

  return (
    <path
      className={className}
      style={Object.assign({}, style, getDashStyle())}
      d={getPathDescription()}
      strokeWidth={strokeWidth}
      stroke={`var(--allie-color-${strokeColor}-main)`}
      fillOpacity={0}
    />
  );
};
